import { render, staticRenderFns } from "./CardCategoria.vue?vue&type=template&id=6c37b326&scoped=true&"
import script from "./CardCategoria.vue?vue&type=script&lang=js&"
export * from "./CardCategoria.vue?vue&type=script&lang=js&"
import style0 from "./CardCategoria.vue?vue&type=style&index=0&id=6c37b326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37b326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VIcon,VList,VListItem,VListItemTitle,VMenu,VRow,VSkeletonLoader})
